import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { UserLeavesViewModel } from '../../../business-entities/user-opening-view-model';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { CookieService } from 'ngx-cookie-service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { UserWorkingHoursService } from '../../../business-services/user-working-hours.service';
import { Observable, Subscription } from 'rxjs';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';

const weekDays: { id: number, name: string, isSelected: boolean }[] = [
  { id: 0, name: 'SUN', isSelected: false },
  { id: 1, name: 'MON', isSelected: false },
  { id: 2, name: 'TUE', isSelected: false },
  { id: 3, name: 'WED', isSelected: false },
  { id: 4, name: 'THU', isSelected: false },
  { id: 5, name: 'FRI', isSelected: false },
  { id: 6, name: 'SAT', isSelected: false }
]

@Component({
  selector: 'app-user-leave',
  templateUrl: './user-leave.component.html',
  styleUrls: ['./user-leave.component.css']
})
export class UserLeaveComponent implements OnInit,OnDestroy {

  constructor(public paggerService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private cookieservice: CookieService,
    private userWorkingHoursService: UserWorkingHoursService,
    private modalService: NgbModal
  ) { }

  @Input() userId: string;
  popupCloseResult = false;
  leavesList: any;
  addUserLeave: any;
  userLeavesDetails: boolean = true;
  editUserLeave: boolean;
  total$: Observable<number>;
  paginationSub: Subscription;
  isLeaveTypeHidden = false;
  leaveId: number;
  userLeaves: UserLeavesViewModel =
    {
      id: null,
      receptionUserId: null,
      startDate: null,
      endDate: null,
      startDateTime: null,
      endDateTime: null,
      option: 1,
      leaveType: 1,
      remark: null,
      selectedDays: '',
      absenceHour: '',
      recurring: 1,
      receptioncLeaveRecurringId: null,
      multiDateList: []
    };
  weekDays: any;

  ngOnInit(): void {
    this.userLeavesDetails = true;
    this.weekDays = weekDays;
    this.GetUserLeavesList();
  }

  onAdd() {
    //make model empty
    this.userLeaves =
    {
      id: null,
      receptionUserId: null,
      startDate: null,
      endDate: null,
      startDateTime: null,
      endDateTime: null,
      option: 1,
      leaveType: 1,
      recurring: 1,
      remark: null,
      selectedDays: '',
      absenceHour: '',
      receptioncLeaveRecurringId: null,
      multiDateList: []
    };
    this.addUserLeave = true;
    this.userLeaves.startDate = null;
    this.userLeaves.endDate = null;
    this.userLeavesDetails = false;
  }

  LeaveTypeChange() {
    this.weekDays = weekDays;
    this.userLeaves.startDate = null;
    this.userLeaves.endDate = null;
    this.userLeaves.startDateTime = null;
    this.userLeaves.endDateTime = null;
    this.userLeaves.remark = null;
    this.userLeaves.selectedDays = '';
    this.userLeaves.absenceHour = '';
    this.userLeaves.receptioncLeaveRecurringId = null;
    this.userLeaves.multiDateList = [];
  }

  OnClose() {
    this.addUserLeave = false;
    this.editUserLeave = false;
    this.ngOnInit();
  }

  AddUserLeaves() {
    let successMessage = this.translate.instant("lblUserLeaveAddedSuccessfully");
    let errorMessage = this.translate.instant("lblErrorMessage");
    let invalidIdErrorMessage = this.translate.instant("lblInvalidUserId");
    let startDateRequiredMessage = this.translate.instant("lblStartDateisrequired");
    let endDateRequiredMessage = this.translate.instant("lblEndDateisrequired");
    let endDateGreaterOrEqualToStartDateMessage = this.translate.instant("lblEndDateGreaterOrEqualToStartDate");
    let provideRemrk = this.translate.instant("lblPleaseProvideRemark");
    if (this.userLeaves.remark === null || this.userLeaves.remark === '') {
      this.spinner.hide();
      this.toaster.error(provideRemrk);
      return;
    }
    if (this.userLeaves.multiDateList?.length <= 0 && this.userLeaves.startDate == null) {
      this.spinner.hide();
      this.toaster.error(startDateRequiredMessage);
      return;
    }
    else if (this.userLeaves.multiDateList?.length <= 0 && this.userLeaves.endDate == null) {
      this.spinner.hide();
      this.toaster.error(endDateRequiredMessage);
      return;
    }
    else if (this.userLeaves.leaveType === Enums.LeaveType.Recurring && (this.userLeaves.recurring <= 0 || this.userLeaves.recurring > 99)) {
      this.spinner.hide();
      let errorMessage = this.translate.instant("lblEnterValidRecurringBetween0to99");
      this.toaster.error(errorMessage);
      return;
    }
    else if (this.userLeaves.leaveType === Enums.LeaveType.Recurring && (this.userLeaves.selectedDays === null || this.userLeaves.selectedDays === '')) {
      this.spinner.hide();
      let errorMessage = this.translate.instant("lblSelectWeekDays");
      this.toaster.error(errorMessage);
      return;
    }
    else {
      let localStartDate; let localEndDate;
      if (this.userLeaves.multiDateList <= 0) {
        localStartDate = Utility.getDateStringToDate(this.userLeaves?.startDate?.split(' ')[0]);
        localStartDate.setHours(this.userLeaves?.startDate?.split(' ')[1]?.split(':')[0]);
        localStartDate.setMinutes(this.userLeaves?.startDate?.split(' ')[1]?.split(':')[1]);
        localEndDate = Utility.getDateStringToDate(this.userLeaves?.endDate?.split(' ')[0]);
        localEndDate.setHours(this.userLeaves?.endDate?.split(' ')[1]?.split(':')[0]);
        localEndDate.setMinutes(this.userLeaves?.endDate?.split(' ')[1]?.split(':')[1]);
        if (localStartDate >= localEndDate && this.userLeaves.leaveType === Enums.LeaveType.DateRange) {
          this.spinner.hide();
          this.toaster.error(endDateGreaterOrEqualToStartDateMessage);
          return;
        }
        if ((new Date(localStartDate?.getFullYear(), localStartDate?.getMonth(), localStartDate?.getDate()) > new Date(localEndDate?.getFullYear(), localEndDate?.getMonth(), localEndDate?.getDate())) && this.userLeaves.leaveType === Enums.LeaveType.Recurring) {
          this.spinner.hide();
          this.toaster.error(endDateGreaterOrEqualToStartDateMessage);
          return;
        }
      }

      if (this.userLeaves.leaveType === Enums.LeaveType.Recurring && this.userLeaves.selectedDays !== null && this.userLeaves.selectedDays !== '') {
        this.userLeaves.selectedDays = this.userLeaves.selectedDays.replace(/^,*$/, '');
      }

      let viewModel = {
        receptionUserId: this.userId,
        langCode: this.cookieservice.get('userSelectedLanguage'),
        userHolidayViewModel: { ...this.userLeaves },
      }
      if (this.userLeaves?.startDate && this.userLeaves?.endDate) {
        viewModel.userHolidayViewModel.endDate = Utility.ConvertLocalDateToUTCDate(localEndDate);
        viewModel.userHolidayViewModel.startDate = Utility.ConvertLocalDateToUTCDate(localStartDate);
      }
      viewModel.userHolidayViewModel.receptionUserId = this.userId;
      if (this.userLeaves.leaveType === Enums.LeaveType.Recurring && (
        (localStartDate?.getHours() > localEndDate?.getHours())
        || ((localStartDate?.getHours() == localEndDate?.getHours()) && (localStartDate?.getMinutes() > localEndDate?.getMinutes()))
        || (localStartDate?.getHours() == localEndDate?.getHours() && localStartDate?.getMinutes() == localEndDate?.getMinutes())
      )) {
        this.spinner.hide();
        let errorMsg = this.translate.instant("lblEndtimeShouldBeGreaterThanStartTime");
        this.toaster.error(errorMsg);
        return;
      }
      this.userWorkingHoursService.addUserLeaves(viewModel).then(res => {
        if (res.responseCode === Constant.SuccessResponseCode) {
          this.userLeavesDetails = true;
          this.toaster.success(successMessage);
          this.GetUserLeavesList();
        }
        else if (res.responseCode === Enums.ErrorCodes.InvalidMechanicId) {
          this.spinner.hide();
          this.toaster.warning(invalidIdErrorMessage);
        }
      }, _error => {
        this.spinner.hide();
        this.toaster.error(errorMessage);
      });
    }
  }

  OnDateChanged(event) {
    let model = {
      startDate: new Date(event + 'Z'),
      endDate: new Date(event + 'Z')
    }
    let isAlreadyExists = false;
    this.userLeaves.multiDateList.forEach(element => {
      model.startDate.setHours(0, 0, 0, 0)
      model.endDate.setHours(23, 59, 0, 0);
      if ((new Date(element.endDate).toDateString() === model.startDate.toDateString()))
        isAlreadyExists = true;
    });
    if (!isAlreadyExists) {
      let dateString = {
        startDate: null,
        endDate: null
      }
      model.startDate.setHours(0, 0, 0, 0)
      model.endDate.setHours(23, 59, 0, 0);
      dateString.startDate = Utility.ConvertLocalDateToUTCDate(model.startDate)
      dateString.endDate = Utility.ConvertLocalDateToUTCDate(model.endDate)
      this.userLeaves.multiDateList.push(dateString)
    }
  }

  GetUserLeavesById(leaveId: number, userLeaveRecurringId: number) {
    this.spinner.show();
    this.userWorkingHoursService.getUserLeavesById(leaveId, userLeaveRecurringId).then((response) => {
      if (response.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.userLeaves = response.responseObject;
        this.userLeaves.startDate = this.userLeaves.startDate ? Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(this.userLeaves.startDate)) : null;
        this.userLeaves.endDate = this.userLeaves.endDate ? Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(this.userLeaves.endDate)) : null;
        let days = this.userLeaves.selectedDays?.split(',');
        if (days?.length > 0) {
          days.forEach(element => {
            this.weekDays[+element].isSelected = true;
          });
        }
      }
      else if (response.responseObject.result && response.responseObject.result.errorCode === Enums.ErrorCodes.NotFound) {
        let errorMessage = this.translate.instant("lblNotFound");
        this.toaster.error(errorMessage);
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  private UserLeavesDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      List.forEach((element, index) => {
        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.endDate = element.endDate ? new Date(element.endDate + 'Z') : null;
        single.startDate = element.startDate ? new Date(element.startDate + 'Z') : null;
        single.isStartDateEditable = new Date(single.startDate) >= new Date();
        single.isEndDateEditable = new Date(single.endDate) >= new Date();
        single.optionId = element.option;
        single.option = this.GetLeaveOptionType(element.option);
        single.leaveType = this.GetLeaveType(element.leaveType);
        single.leaveTypeId = element.leaveType;
        single.remark = element.remark;
        single.selectedDays = element.selectedDays ? this.GetWeekDays(element.selectedDays) : '-';
        single.absenceHour = element.absenceHour;
        single.userLeaveRecurringId = element.userLeaveRecurringId;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.paggerService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.paggerService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.paggerService.pageSize * (this.paggerService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }

  GetLeaveOptionType(option: number) {
    if (this.isLeaveTypeHidden) {
      switch (option) {
        case Enums.CustomLeaveOptionType.Sykemelding:
          return 'Sykemelding';
        case Enums.CustomLeaveOptionType.Egenmelding:
          return 'Egenmelding';
        case Enums.CustomLeaveOptionType.Kurstrening:
          return 'Kurs\trening';
        case Enums.CustomLeaveOptionType.Ferie:
          return 'Ferie';
        case Enums.CustomLeaveOptionType.Permisjon:
          return 'Permisjon';
        default:
          return '';
      }
    } else {
      switch (option) {
        case Enums.LeaveOptionType.Personal:
          return 'Personal';
        case Enums.LeaveOptionType.Business:
          return 'Business';
        default:
          return '';
      }
    }
  }

  GetLeaveType(leaveType: number) {
    switch (leaveType) {
      case Enums.LeaveType.DateRange:
        return 'DateRange';
      case Enums.LeaveType.MultiDay:
        return 'MultiDay';
      case Enums.LeaveType.Recurring:
        return 'Recurring';
      default:
        return '';
    }
  }

  GetWeekDays(selectedDays: string) {
    let outputArray = [];
    selectedDays.split(',').forEach(element => {
      switch (+element) {
        case Enums.WeekDays.Sunday:
          outputArray.push('Sunday');
          break;
        case Enums.WeekDays.Monday:
          outputArray.push('Monday');
          break;
        case Enums.WeekDays.Tuesday:
          outputArray.push('Tuesday');
          break;
        case Enums.WeekDays.Wednesday:
          outputArray.push('Wednesday');
          break;
        case Enums.WeekDays.Thursday:
          outputArray.push('Thursday');
          break;
        case Enums.WeekDays.Friday:
          outputArray.push('Friday');
          break;
        case Enums.WeekDays.Saturday:
          outputArray.push('Saturday');
          break;
        default:
          outputArray.push('');
      }
    });
    return outputArray.join(',');
  }

  onDaySelected(item: any, event: any) {
    let days = [];
    days = this.userLeaves.selectedDays?.split(',');
    if (days.indexOf('') > -1) {
      days.splice(days.indexOf(''), 1);
    }
    if (item.isSelected) {
      if (!(days.includes(item.id.toString()))) {
        days.push(item.id.toString());
      }
    }
    else {
      if (days.includes(item.id.toString())) {
        days.splice(days.indexOf(item.id.toString()), 1)
      }
    }
    this.userLeaves.selectedDays = days.join(',');
  }

  GetUserLeavesList() {
    this.spinner.show();
    let internalErrorMessage = this.translate.instant("lblGetLeaveInternalError");
    let invalidIdErrorMessage = this.translate.instant("lblInvalidMechanicId");
    this.userWorkingHoursService.getUserLeaveList(this.userId).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.paggerService.dataSource = response.responseObject;
        this.paginationSub = this.paggerService.dealers$.subscribe((result: any) => {
          this.leavesList = this.UserLeavesDataMapper(result);
        });
        this.total$ = this.paggerService.total$;
        this.spinner.hide();
      }
      else if (response.responseCode === Enums.ErrorCodes.InterrnalError) {
        this.spinner.hide();
        this.toaster.error(internalErrorMessage);
      }
      else if (response.responseCode === Enums.ErrorCodes.InvalidMechanicId) {
        this.spinner.hide();
        this.toaster.warning(invalidIdErrorMessage);
      }
      this.spinner.hide();
    });
  }

  onEdit(leave: any) {
    this.editUserLeave = true;
    this.userLeavesDetails = false;
    this.leaveId = leave.id;
    this.GetUserLeavesById(this.leaveId, leave.userLeaveRecurringId);
  }

  editUserLeaves() {
    let successMessage = this.translate.instant("lblUserLeaveEditedSuccessfully");
    let errorMessage = this.translate.instant("lblMechanicLeavesDetailsAreNotEdited");
    let startDateRequiredMessage = this.translate.instant("lblStartDateisrequired");
    let endDateRequiredMessage = this.translate.instant("lblEndDateisrequired");
    let endDateGreaterOrEqualToStartDateMessage = this.translate.instant("lblEndDateGreaterOrEqualToStartDate");
    this.spinner.show();
    let provideRemrk = this.translate.instant("lblPleaseProvideRemark");
    if (this.userLeaves.remark === null || this.userLeaves.remark === '') {
      this.spinner.hide();
      this.toaster.error(provideRemrk);
      return;
    }
    if (this.userLeaves.multiDateList?.length <= 0 && this.userLeaves.startDate == null) {
      this.spinner.hide();
      this.toaster.error(startDateRequiredMessage);
      return;
    }
    else if (this.userLeaves.multiDateList?.length <= 0 && this.userLeaves.endDate == null) {
      this.spinner.hide();
      this.toaster.error(endDateRequiredMessage);
      return;
    }
    else if (this.userLeaves.leaveType === Enums.LeaveType.Recurring && (this.userLeaves.recurring <= 0 || this.userLeaves.recurring > 99)) {
      this.spinner.hide();
      let errorMessage = this.translate.instant("lblEnterValidRecurringBetween0to99");
      this.toaster.error(errorMessage);
      return;
    }
    else if (this.userLeaves.leaveType === Enums.LeaveType.Recurring && (this.userLeaves.selectedDays === null || this.userLeaves.selectedDays === '')) {
      this.spinner.hide();
      let errorMessage = this.translate.instant("lblSelectWeekDays");
      this.toaster.error(errorMessage);
      return;
    }

    else {
      let localStartDate; let localEndDate;
      if (this.userLeaves.multiDateList <= 0) {
        localStartDate = Utility.getDateStringToDate(this.userLeaves?.startDate?.split(' ')[0]);
        localStartDate.setHours(this.userLeaves?.startDate?.split(' ')[1]?.split(':')[0]);
        localStartDate.setMinutes(this.userLeaves?.startDate?.split(' ')[1]?.split(':')[1]);

        localEndDate = Utility.getDateStringToDate(this.userLeaves?.endDate?.split(' ')[0]);
        localEndDate.setHours(this.userLeaves?.endDate?.split(' ')[1]?.split(':')[0]);
        localEndDate.setMinutes(this.userLeaves?.endDate?.split(' ')[1]?.split(':')[1]);
        if (localStartDate >= localEndDate && this.userLeaves.leaveType === Enums.LeaveType.DateRange) {
          this.spinner.hide();
          this.toaster.error(endDateGreaterOrEqualToStartDateMessage);
          return;
        }
        if ((new Date(localStartDate?.getFullYear(), localStartDate?.getMonth(), localStartDate?.getDate()) > new Date(localEndDate?.getFullYear(), localEndDate?.getMonth(), localEndDate?.getDate())) && this.userLeaves.leaveType === Enums.LeaveType.Recurring) {
          this.spinner.hide();
          this.toaster.error(endDateGreaterOrEqualToStartDateMessage);
          return;
        }
        if (this.userLeaves.leaveType === Enums.LeaveType.Recurring) {
          let yestDate = new Date();
          yestDate.setDate(new Date().getDate() - 1);
        }
      }
      if (this.userLeaves.leaveType === Enums.LeaveType.Recurring && this.userLeaves.selectedDays !== null && this.userLeaves.selectedDays !== '') {
        this.userLeaves.selectedDays = this.userLeaves.selectedDays.replace(/^,*$/, '');
      }
      this.userLeaves.multiDateList = [];
      let viewModel =
      {
        receptionUserId: this.userId,
        langCode: this.cookieservice.get('userSelectedLanguage'),
        UserHolidayViewModel: { ...this.userLeaves }
      }
      if (this.userLeaves?.startDate && this.userLeaves?.endDate) {
        viewModel.UserHolidayViewModel.endDate = Utility.ConvertLocalDateToUTCDate(localEndDate);
        viewModel.UserHolidayViewModel.startDate = Utility.ConvertLocalDateToUTCDate(localStartDate);
      }
      if (this.userLeaves.leaveType === Enums.LeaveType.Recurring && (
        (localStartDate?.getHours() > localEndDate?.getHours())
        || ((localStartDate?.getHours() == localEndDate?.getHours()) && (localStartDate?.getMinutes() > localEndDate?.getMinutes()))
        || (localStartDate?.getHours() == localEndDate?.getHours() && localStartDate?.getMinutes() == localEndDate?.getMinutes())
      )) {
        this.spinner.hide();
        let errorMsg = this.translate.instant("lblEndtimeShouldBeGreaterThanStartTime");
        this.toaster.error(errorMsg);
        return;
      }

      this.userWorkingHoursService.updateUserLeave(viewModel).then(res => {

        if (res.responseCode === Constant.SuccessResponseCode) {
          if (!(res?.responseObject?.isValid) && (res?.responseObject?.errorCode === Constant.MechanicLeaveAlreadyExists)) {
            let errorMsg = this.translate.instant("lblUserLeaveAlreadyExists");
            this.toaster.error(errorMsg)
          }
          else if (!(res?.responseObject?.isValid) && (res?.responseObject?.errorCode === Constant.NoMechanicLeaveExists)) {
            let errorMsg = this.translate.instant("lblNoLeaveExists");
            this.toaster.error(errorMsg)
          }
          else {
            localStorage.setItem('lastMechanic', JSON.stringify(this.userLeaves));
            this.toaster.success(successMessage);
            this.editUserLeave = false;
            this.ngOnInit();
          }
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
          this.toaster.error(errorMessage);
        }
      }, _error => {
        this.spinner.hide();
        this.toaster.error(errorMessage);
      });
    }
  }

  DeleteLeave(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblLeaves"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.userWorkingHoursService.deleteLeave(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let deletedmsg = this.translate.instant("lblUserLeaveDeletedSuccessfully");
            this.toaster.success(deletedmsg)
            this.ngOnInit();
          }
        });
      }
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  checkRecurring()
  {
    if(this.userLeaves.recurring < 1 || this.userLeaves.recurring > 99)
    {
      let errorMessage = this.translate.instant("lblEnterValidRecurringBetween0to99");
      this.toaster.error(errorMessage);
      return;  
    }
  }

  ngOnDestroy(): void {
    this.userLeavesDetails = false;
    this.paggerService.dataSource = [];
  }
}
